<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5555 10.0002C5.5555 9.27794 5.11106 8.66683 4.44439 8.44461V6.55572C5.11106 6.3335 5.5555 5.72239 5.5555 5.00016C5.5555 4.05572 4.83328 3.3335 3.88883 3.3335C2.94439 3.3335 2.22217 4.05572 2.22217 5.00016C2.22217 5.72239 2.66661 6.3335 3.33328 6.55572V8.44461C2.66661 8.66683 2.22217 9.27794 2.22217 10.0002C2.22217 10.7224 2.66661 11.3335 3.33328 11.5557V13.4446C2.66661 13.6668 2.22217 14.2779 2.22217 15.0002C2.22217 15.9446 2.94439 16.6668 3.88883 16.6668C4.83328 16.6668 5.5555 15.9446 5.5555 15.0002C5.5555 14.2779 5.11106 13.6668 4.44439 13.4446V11.5557C5.11106 11.3335 5.5555 10.7224 5.5555 10.0002Z"
      fill="#D72638"
    />
    <path
      d="M17.2223 5.55545H8.33339C8.00005 5.55545 7.77783 5.33322 7.77783 4.99989C7.77783 4.66656 8.00005 4.44434 8.33339 4.44434H17.2223C17.5556 4.44434 17.7778 4.66656 17.7778 4.99989C17.7778 5.33322 17.5556 5.55545 17.2223 5.55545Z"
      fill="#D72638"
    />
    <path
      d="M17.2223 10.5554H8.33339C8.00005 10.5554 7.77783 10.3332 7.77783 9.99989C7.77783 9.66656 8.00005 9.44434 8.33339 9.44434H17.2223C17.5556 9.44434 17.7778 9.66656 17.7778 9.99989C17.7778 10.3332 17.5556 10.5554 17.2223 10.5554Z"
      fill="#D72638"
    />
    <path
      d="M17.2223 15.5554H8.33339C8.00005 15.5554 7.77783 15.3332 7.77783 14.9999C7.77783 14.6666 8.00005 14.4443 8.33339 14.4443H17.2223C17.5556 14.4443 17.7778 14.6666 17.7778 14.9999C17.7778 15.3332 17.5556 15.5554 17.2223 15.5554Z"
      fill="#D72638"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
